<div class="order-tracking order-container">
    <div (click)="close()">
        <div class="modal-header">
            <button type="button" class="close text-grey" (click)="close()">&times;</button>
            <h3 class="modal-title" id="modal-title"><span
                translate="cart.order.history.order.tracking.modal.title"></span>
            </h3>
        </div>
        <div class="modal-body" id="modal-body">
            <div class="card">
                <div class="card-header">
                    <span class="pull-left" translate="cart.order.history.shipping.method"></span>
                    <span translate="cart.order.history.shipping.date"></span>
                </div>
                <div class="card-body">
                    <span>{{ orderView.shippingMethod?.methodName }}</span>
                    <span>{{ orderView.packslips[0]?.shipDate | usanadate: 'mediumDate':orderView.warehouse?.timezone | async }}</span>
                </div>
                <div class="card-footer">
                    <div class="card-header">
                        <span class="pull-left" translate="cart.order.history.order.tracking.number"></span>
                    </div>
                    <div class="card-body">
                        @for (packslip of orderView.packslips; track packslip.packslipId) {
                            <div class="layout-block">
                                @for (pkg of packslip.packages; track pkg.packageId) {
                                    <a target="_blank" [href]="pkg.trackingLink">
                                        {{ pkg.trackingNumber }} <i class="fa-solid fa-arrow-up-right-from-square"
                                                                    aria-hidden="true"></i>
                                    </a>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
